import { authAxios as axios } from "api-generate-types/src/axios";
import { IBreakdown } from "shared/models/breakdown";

import config from "config/global";

class BreakdownService {
  private url: string;

  constructor({ url }: { url: string }) {
    this.url = url;
  }

  public async get(
    breakdownId: string,
    abortController?: AbortController
  ): Promise<IBreakdown> {
    const response = await axios(`${this.url}/${breakdownId}`, {
      signal: abortController?.signal,
    });

    return response.data;
  }
}

export default new BreakdownService({
  url: config.breakdownsApiUrl,
});
